import React from 'react';
import type { World } from '../data/worlds';
import { getWorldLessons } from '../data/worldLessons';
interface WorldCardProps {
  world: World;
  /** Show the one-line description under the name. */
  withDescription?: boolean;
  /** Opens the shared lesson preview. The clicked button is passed for focus return. */
  onOpen: (world: World, trigger: HTMLButtonElement) => void;
}

/**
 * The whole card is one button: it lives in the heading and stretches over the card
 * with a pseudo-element, so there are no nested interactive elements.
 */
export function WorldCard({
  world,
  withDescription = false,
  onOpen
}: WorldCardProps) {
  const count = getWorldLessons(world.slug).length;
  return <article id={world.slug} className="group relative flex h-full scroll-mt-28 flex-col" data-id="element-312" data-mp="3c52ubn20ovh1">
      <div className="rounded-3xl border-2 border-ink bg-cream-field p-3 shadow-chunky transition-transform duration-200 ease-out group-hover:-translate-y-1" data-id="element-313" data-mp="2ofs1crqws5dg">
        <img src={world.art} alt={world.alt} loading="lazy" decoding="async" width={world.width} height={world.height} className="aspect-square w-full object-contain" data-id="element-314" data-mp="2ke6hunjvcsua" />
      </div>
      <h3 className="mt-4 font-display text-[22px] leading-snug text-ink" data-id="element-315" data-mp="27n712ki6ykvj">
        <button type="button" aria-haspopup="dialog" aria-label={`${world.name}: see the ${count} adventures`} onClick={event => onOpen(world, event.currentTarget)} className="text-left outline-none after:absolute after:-inset-2 after:rounded-[28px] after:content-[''] focus-visible:after:ring-4 focus-visible:after:ring-coral" data-id="element-316" data-mp="2cma82ahqf165">
          {world.name}
        </button>
      </h3>
      {withDescription && <p className="mt-1.5 text-[17px] text-ink-soft" data-id="element-317" data-mp="1txdde5ifa6ne">{world.description}</p>}
      <p aria-hidden="true" className="mt-auto pt-3 text-[16px] font-bold text-ink" data-id="element-318" data-mp="30bckn3xie3ts">
        See the {count} adventures{' '}
        <span className="inline-block text-coral transition-transform duration-150 ease-out group-hover:translate-x-0.5" data-id="element-319" data-mp="35dbqqlkmveuf">
          →
        </span>
      </p>
    </article>;
}